export enum ScheduleStatus {
    CONFIRMED = 'CONFIRMED',
    CANCELLED = 'CANCELLED'
}
